const en = {
  actions: {
    cancel: 'Cancel',
    delete: 'Delete',
    openFolder: 'Open {{folderName}} folder',
    preview: 'Preview',
    rename: 'Rename',
  },
  delete: {
    deleting: 'Deleting...',
    description:
      'Are you sure you want to delete "{{fileName}}"? This action cannot be undone.',
    error: 'Failed to delete file',
    submit: 'Delete',
    success: 'File deleted successfully',
    title: 'Delete File',
  },
  download: {
    fallback: 'Failed to download file. Opening in browser.',
  },
  fileName: 'File Name',
  folder: 'Folder',
  folderType: {
    ASSIGNMENT: 'Assignment',
    DISPOSAL: 'Disposal',
    DOCUMENT: 'Document',
    INITIAL_SETUP: 'Initial Setup',
    INSTALLATION: 'Installation',
    INVENTORY: 'Inventory',
    RECEIVING: 'Receiving',
    REPAIR: 'Repair',
    REPLACEMENT: 'Replacement',
    RETRIEVAL: 'Retrieval',
    RETURN: 'Return',
  },
  mimeType: 'File Type',
  rename: {
    description: 'Change the file name',
    error: 'Failed to rename file',
    newFileName: 'New File Name',
    placeholder: 'Enter file name',
    submit: 'Rename',
    success: 'File renamed successfully',
    title: 'Rename File',
    updating: 'Updating...',
  },
  title: 'File Management',
  updatedAt: 'Last Update Date',
  updatedBy: 'Last Updater',
  upload: {
    button: 'Upload File',
    description: 'Upload files related to this device',
    error: {
      extensionMismatch: 'File extension does not match the original file.',
      fileNameRequired: 'File name is required.',
      fileNameTooLong:
        'File name is too long. Maximum {{maxLength}} characters allowed.',
      fileSizeExceeded:
        'File size ({{actualSize}}MB) exceeds the maximum allowed size of {{maxSize}}MB.',
      invalidCharacters: 'File name contains invalid characters.',
      invalidFileType:
        'File type "{{mimeType}}" is not supported. Only images (JPEG, PNG, GIF) and PDF files are allowed.',
      missingExtension: 'File name must have an extension.',
      unknown: 'File validation failed.',
    },
    helpText: 'Supported formats: JPEG, PNG, GIF, PDF (Max 100MB)',
    originalFileName: 'Original file name',
    placeholder: 'Enter file name',
    selectFile: 'Select File',
    selectedFile: 'Selected File',
    submit: 'Upload',
    success: 'File uploaded successfully',
    title: 'Upload File',
    uploading: 'Uploading...',
    validationError: 'File is invalid',
  },
};

export default en;
